import { createStore } from "./createStore";

const base = (set) => ({
  isRecording: false,
  isAudioPlaying: false,
  isAITalking: false,
  bufferingStatus: false,
  isNudgePending: false,
  micCaptureProfile: null,

  setIsRecording: (val) => set({ isRecording: val }),
  setIsAudioPlaying: (val) => set({ isAudioPlaying: val }),
  setIsAITalking: (val) => set({ isAITalking: val }),
  setBufferingStatus: (val) => set({ bufferingStatus: val }),
  setIsNudgePending: (val) => set({ isNudgePending: val }),
  setMicCaptureProfile: (val) => set({ micCaptureProfile: val }),
});

export const useAudioStore = createStore("AudioStore", base);
